import { render, staticRenderFns } from "./ReceiverIcons.vue?vue&type=template&id=480e5966&scoped=true&"
import script from "./ReceiverIcons.vue?vue&type=script&lang=js&"
export * from "./ReceiverIcons.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverIcons.vue?vue&type=style&index=0&id=480e5966&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480e5966",
  null
  
)

export default component.exports